import { render, staticRenderFns } from "./ExpirationSettings.vue?vue&type=template&id=35b7422f&scoped=true&"
import script from "./ExpirationSettings.vue?vue&type=script&lang=ts&"
export * from "./ExpirationSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ExpirationSettings.vue?vue&type=style&index=0&id=35b7422f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7422f",
  null
  
)

export default component.exports